import { useState } from "react";
import { Link } from "react-router-dom";
import { useLocale } from "../contexts/LocaleContext";

const TABS = [
  { id: "watches", label: "Watches", filter: () => true },
  { id: "men", label: "Men's", filter: (p) => p.gender === "men" },
  { id: "women", label: "Women's", filter: (p) => p.gender === "women" },
];

export default function TrendingNow({ items }) {
  const { fmt } = useLocale();
  const [tab, setTab] = useState("watches");
  const filtered = (items || []).filter(TABS.find(t=>t.id===tab).filter).slice(0, 10);
  return (
    <section className="bg-[#FAF7F2] border-y border-black/5 py-24">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-8">
          <div>
            <div className="overline mb-3">What's Hot</div>
            <h2 className="font-display text-4xl md:text-5xl text-dark tracking-tight">Trending Now</h2>
          </div>
          <div className="flex gap-2">
            {TABS.map(t => {
              const selected = tab === t.id;
              return (
                <button
                  key={t.id}
                  data-testid={`trend-${t.id}`}
                  onClick={() => setTab(t.id)}
                  className={`text-[11px] uppercase tracking-luxe px-4 py-2 border transition-colors ${selected ? "bg-copper text-white border-copper hover:bg-[#A0834F]" : "bg-transparent text-gray-700 border-black/15 hover:border-copper hover:text-copper"}`}
                  style={selected ? { backgroundColor: "#B89766", color: "#fff", borderColor: "#B89766" } : undefined}
                >
                  {t.label}
                </button>
              );
            })}
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-x-5 gap-y-10">
          {filtered.map(p => (
            <Link to={`/product/${p.id}`} key={p.id} className="product-card group">
              <div className="aspect-square overflow-hidden bg-white">
                <img src={p.images?.[0]} alt={p.name} className="w-full h-full object-cover"/>
              </div>
              <div className="pt-4">
                <div className="text-[10px] uppercase tracking-luxe text-copper">{p.brand}</div>
                <div className="text-sm text-dark mt-1 line-clamp-2">{p.name}</div>
                <div className="text-sm text-gray-700 mt-1">{fmt(p.price)}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
